import React from 'react'
import { forwardRef, useCallback, useEffect, useState } from 'react'

import { MessageHoverIcon } from '../../media/MessageHoverIcon'
import { MessageIcon } from '../../media/MessageIcon'
import { MessageOpenIcon } from '../../media/MessageOpenIcon'
import { WhatsappIcon } from '../../media/WhatsappIcon'
import { TelegramIcon } from '../../media/TelegramIcon'
import { MaxMessengerIcon } from '../../media/MaxMessengerIcon'

import { PopoverModal } from '../PopoverModal'

export const ChatButton = forwardRef(function (props, ref) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <span className="fixed bottom-4 right-4 h-[48px] w-[49px] z-[999]">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>

      <button
        ref={ref}
        {...props}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative rounded-full shadow-md hover:shadow-lg transition-shadow cursor-pointer focus:outline-none"
      >
        {/** @ts-expect-error open prop */}
        {props.open && <MessageOpenIcon />}
        {/** @ts-expect-error open prop */}
        {!props.open && !isHovered && <MessageIcon />}
        {/** @ts-expect-error open prop */}
        {!props.open && isHovered && <MessageHoverIcon />}
      </button>
    </span>
  )
})

ChatButton.displayName = 'ChatButton'

const VERBOX_WIDGET_ID = 'supportScript'
const VERBOX_WIDGET_HASH = '239adaea28643108b9b36149fa9fe960'
const VERBOX_WIDGET_SRC = 'https://admin.verbox.ru/support/support.js'
const VERBOX_WIDGET_FALLBACK_SRC =
  'https://static.site-chat.me/support/support.int.js'

function isLocalHostname(hostname) {
  return (
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    hostname === '0.0.0.0' ||
    hostname.startsWith('127.') ||
    hostname === '::1' ||
    hostname === '[::1]'
  )
}

function ensureVerboxScript(useFallback = false) {
  if (typeof window === 'undefined') return null
  if (isLocalHostname(window.location.hostname)) return null

  window.supportAPIMethod = 'Verbox'
  if (!window.Verbox) {
    window.Verbox = function () {
      window.Verbox.q = window.Verbox.q ? window.Verbox.q : []
      window.Verbox.q.push(arguments)
    }
  }

  const existingScript = document.getElementById(VERBOX_WIDGET_ID)
  if (existingScript) return existingScript

  const script = document.createElement('script')
  script.id = VERBOX_WIDGET_ID
  script.async = true
  script.src = `${
    useFallback ? VERBOX_WIDGET_FALLBACK_SRC : VERBOX_WIDGET_SRC
  }?h=${VERBOX_WIDGET_HASH}`
  if (!useFallback) {
    script.onerror = () => {
      script.remove()
      ensureVerboxScript(true)
    }
  }

  const container = document.head || document.body
  container.appendChild(script)
  return script
}

export function ChatWidget() {
  useEffect(() => {
    ensureVerboxScript()
  }, [])

  const openVerboxChat = useCallback(() => {
    if (typeof window === 'undefined') return

    const script = ensureVerboxScript()
    if (!script) return

    window.Verbox('openSupport')
  }, [])

  return (
    <>
      <PopoverModal
        className="rounded-xl border-none bg-white shadow-[0px_2px_15px_0px_rgba(116,122,138,0.3)]"
        openButton={ChatButton}
        position={{ to: 'left end', gap: '16px' }}
      >
        <div className="p-5 w-[280px] rounded-xl z-[20] relative bg-white">
          <div className="font-medium text-gray-1000">
            Напишите нам в удобный мессенджер — мы быстро ответим
          </div>

          <div className="flex flex-col gap-2 mt-4">
            <button
              type="button"
              onClick={openVerboxChat}
              className="w-full truncate text-left"
            >
              <div
                className="flex gap-3 items-center text-sm text-gray-1000 font-medium
                cursor-pointer rounded-lg h-12 px-4 bg-[#f8f6e7]
                hover:bg-[#fbf4c3] transition-all duration-300"
              >
                <img
                  src="/assets/verbox-logo.png"
                  alt="Verbox"
                  width={26}
                  height={26}
                />
                Написать в онлайн-чат
              </div>
            </button>

            <a
              href="https://max.ru/u/f9LHodD0cOLjCo2m378JrRYN9Stt0MF7XfTi012zi1R-w5_1LD8A8BXpoOI"
              target="_blank"
              className="truncate"
              rel="noreferrer"
            >
              <div
                className="flex gap-3 items-center text-sm text-gray-1000 font-medium cursor-pointer rounded-lg h-12 px-4 bg-[#F0E8FF]
                hover:bg-[#E5DCF6] transition-all duration-300"
              >
                <MaxMessengerIcon width="26" height="26" /> Написать в Max
              </div>
            </a>

            <a
              href="https://t.me/priceninja_support"
              target="_blank"
              className="truncate"
              rel="noreferrer"
            >
              <div
                className="flex gap-3 items-center text-sm text-gray-1000 font-medium cursor-pointer rounded-lg h-12 px-4 bg-[rgba(11,137,200,0.12)]
                hover:bg-[rgba(18,78,108,0.12)] transition-all duration-300"
              >
                <TelegramIcon width="26" height="25" /> Написать в Telegram
              </div>
            </a>

            <a
              href="https://wa.me/79773333882"
              target="_blank"
              className="truncate"
              rel="noreferrer"
            >
              <div
                className="flex gap-3 items-center text-sm text-gray-1000 font-medium cursor-pointer rounded-lg h-12 px-4 bg-[rgba(0,230,118,0.12)]
                hover:bg-[rgba(12,112,64,0.12)] transition-all duration-300"
              >
                <WhatsappIcon width="26" height="25" /> Написать в WhatsApp
              </div>
            </a>
          </div>
        </div>

        <div className="absolute w-3 h-3 bg-white rotate-45 shadow-[0px_2px_15px_0px_rgba(116,122,138,0.3)] right-[-6px] bottom-4" />
      </PopoverModal>
    </>
  )
}
